import { ChainId } from '@ui/types/chain';
import { USD_DECIMALS } from '@ui/constants/numbersDecimals';
import { toReadableValue } from '@ui/lib/bignumber';
import BigNumber from 'bignumber.js';

import { oraclePriceControllerApi } from '../../backend/clients/clients';
import type {
  LatestPairPricesRequestBlockChainEnum,
} from '../../backend/generated/models';
import { toServerBlockChain } from '../../backend/utils';

type PairOraclePriceParam = {
  pairBase: string;
  baseSymbol: string;
};

type OraclePriceRow = {
  symbol: string;
  price: BigNumber;
};

export const oracleLatestPriceBatchQuery = {
  getKey: ({
    pairs,
    chainId,
  }: {
    pairs: PairOraclePriceParam[];
    chainId: ChainId;
  }) => [
    'oracle-latest-price-batch',
    chainId,
    pairs.map((pair) => pair.pairBase).sort(),
  ],
  getFn:
    ({
      pairs,
      chainId,
    }: {
      pairs: PairOraclePriceParam[];
      chainId: ChainId;
    }) =>
    async () => {
      if (pairs.length === 0) {
        return [];
      }

      const response = await oraclePriceControllerApi.getLatestPairPrices({
        latestPairPricesRequest: {
          pairBases: pairs.map((pair) => pair.pairBase),
          blockChain:
            toServerBlockChain<LatestPairPricesRequestBlockChainEnum>(chainId),
        },
      });

      return pairs.reduce<OraclePriceRow[]>((rows, pair) => {
        const price = response.prices[pair.pairBase];
        if (price) {
          rows.push({
            symbol: pair.baseSymbol,
            price: toReadableValue(BigInt(price), USD_DECIMALS),
          });
        }

        return rows;
      }, []);
    },
};
